import React from "react";
import { Box, Typography, Card, Button, Grid, Divider } from "@mui/material";

const dummyRewards = [
  {
    title: "Login rewards",
    description: "+50",
    actionText: "Go",
  },
  {
    title: "Turn on notifications",
    description: "+30",
    actionText: "Go",
  },
  {
    title: "Bind email",
    description: "+30",
    actionText: "Go",
  },
];

const Rewards = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#000",
        color: "#fff",
        minHeight: "100vh",
        padding: "16px",
      }}
    >
      {/* Balance and Streak Section */}
      <Box
        sx={{
          backgroundColor: "#1a1a1a",
          borderRadius: "16px",
          padding: "16px",
          textAlign: "center",
          mb: 4,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Balance: <span style={{ color: "#f50057" }}>0</span>
        </Typography>
        <Typography
          variant="body2"
          sx={{ marginTop: "8px", color: "#aaa" }}
        >
          Check-in Streak: 0 day(s)
        </Typography>

        {/* Streak Progress */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "16px",
            backgroundColor: "#222",
            borderRadius: "12px",
            padding: "8px",
          }}
        >
          {["+10", "+10", "+20", "+25", "+30", "+30", "+50"].map((streak, idx) => (
            <Box key={idx} sx={{ textAlign: "center", color: "#fff" }}>
              <Typography variant="caption">{streak}</Typography>
              <Box
                sx={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: idx === 0 ? "#f50057" : "#666",
                  borderRadius: "50%",
                  margin: "8px auto",
                }}
              />
            </Box>
          ))}
        </Box>

        <Button
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#f50057",
            color: "#fff",
            borderRadius: "24px",
            marginTop: "16px",
            padding: "8px 16px",
            textTransform: "none",
          }}
        >
          Check In
        </Button>
      </Box>

      {/* Benefits Section */}
      <Box mb={4}>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", marginBottom: "16px" }}
        >
          Today's Benefits
        </Typography>
        <Grid container spacing={2}>
          {/* Example Apps and Games */}
          {["Chapters: Interactive", "Block Odyssey", "Kiss: Read & Write"].map(
            (app, idx) => (
              <Grid item xs={4} key={idx}>
                <Card
                  sx={{
                    backgroundColor: "#222",
                    borderRadius: "12px",
                    padding: "8px",
                    textAlign: "center",
                    color: "#fff",
                  }}
                >
                  <Box
                    component="img"
                    src={`https://via.placeholder.com/80?text=${app}`} // Replace with actual app images
                    alt={app}
                    sx={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "12px",
                      marginBottom: "8px",
                    }}
                  />
                  <Typography variant="body2" sx={{ fontSize: "12px" }}>
                    {app}
                  </Typography>
                </Card>
              </Grid>
            )
          )}
        </Grid>
      </Box>

      {/* Rewards Section */}
      <Box>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", marginBottom: "16px" }}
        >
          Rewards
        </Typography>
        {dummyRewards.map((reward, idx) => (
          <Box
            key={idx}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#222",
              borderRadius: "12px",
              padding: "16px",
              marginBottom: "12px",
            }}
          >
            <Box>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                {reward.title}
              </Typography>
              <Typography variant="body2" sx={{ color: "#aaa" }}>
                {reward.description}
              </Typography>
            </Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#f50057",
                color: "#fff",
                borderRadius: "24px",
                padding: "8px 16px",
                textTransform: "none",
              }}
            >
              {reward.actionText}
            </Button>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Rewards;